import { render, staticRenderFns } from "./InfoTableCampaign.vue?vue&type=template&id=3155d9a6"
import script from "./InfoTableCampaign.vue?vue&type=script&lang=js"
export * from "./InfoTableCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports